import { render } from "./AllAssetsList.vue?vue&type=template&id=b22e1e6c&scoped=true"
import script from "./AllAssetsList.vue?vue&type=script&lang=js"
export * from "./AllAssetsList.vue?vue&type=script&lang=js"

import "./AllAssetsList.vue?vue&type=style&index=0&id=b22e1e6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b22e1e6c"]])

export default __exports__